import { Box, Tab, TabList, Tabs, Tooltip, tabClasses } from "@mui/joy";
import { Building2, FileText, ShieldCheck } from "lucide-react";

interface VerticalTabsProps {
    value: string;
    onChange: (value: string) => void;
}

const TABS = [
    { value: "profile", title: "Profile", icon: Building2 },
    { value: "access", title: "Access & status", icon: ShieldCheck },
    { value: "contract", title: "Contract document", icon: FileText },
] as const;

export function VerticalTabs({ value, onChange }: VerticalTabsProps) {
    return (
        <Box
            sx={{
                height: "100%",
                width: 70,
                borderRight: "1px solid",
                borderColor: "divider",
                bgcolor: "background.surface",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                pt: 2,
                flexShrink: 0,
            }}
        >
            <Tabs
                orientation="vertical"
                value={value}
                onChange={(_, val) => typeof val === "string" && onChange(val)}
                sx={{
                    bgcolor: "transparent",
                    [`& .${tabClasses.root}`]: {
                        minHeight: 48,
                        width: 48,
                        borderRadius: "4px",
                        justifyContent: "center",
                        mb: 1,
                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                        "&:hover": {
                            bgcolor: "background.level1",
                        },
                        [`&[aria-selected="true"]`]: {
                            bgcolor: "primary.softBg",
                            color: "primary.plainColor",
                        },
                    },
                }}
            >
                <TabList
                    disableUnderline
                    sx={{
                        flexDirection: "column",
                        gap: 0,
                        p: 0,
                        alignItems: "center",
                    }}
                >
                    {TABS.map(({ value: tabValue, title, icon: Icon }) => (
                        <Tooltip
                            key={tabValue}
                            title={title}
                            placement="right"
                            arrow
                            variant="soft"
                            size="md"
                        >
                            <Tab value={tabValue} disableIndicator sx={{ p: 1 }}>
                                <Icon size={18} />
                            </Tab>
                        </Tooltip>
                    ))}
                </TabList>
            </Tabs>
        </Box>
    );
}
